import { Injectable } from "@angular/core";
import { MathUtils as utils } from "~app/common/utils/math-utils";

@Injectable({
    providedIn: "root"
})
export class FooterAggregationService {
    runAggregation(agg: any, rows: any[], field: string) {
        const data = rows.map(r => r[field]);
        if (typeof agg === "function") {
            return agg(data, rows);
        }

        switch (agg) {
            case "sum":
                return utils.sum(data);
            case "avg":
                return utils.avg(data);
            case "max":
                return utils.max(data);
            case "min":
                return utils.min(data);
            default:
                return undefined;
        }
    }
}
